/** Compteurs de réactions d'un message, indexés par emoji. */
export type ReactionCounts = Record<string, number>;

/**
 * Fusionne les compteurs locaux (deltas Ably reçus pendant le jitter, partis de 0)
 * avec ceux de l'historique serveur. On garde le maximum emoji par emoji : ni l'un
 * ni l'autre n'est fiable seul, et un compteur affiché ne doit jamais baisser.
 */
export function mergeReactionCounts(
  local: ReactionCounts,
  history: ReactionCounts,
): ReactionCounts {
  const merged: ReactionCounts = { ...local };
  for (const [emoji, count] of Object.entries(history)) {
    merged[emoji] = Math.max(merged[emoji] ?? 0, count);
  }
  return merged;
}

/** Applique {@link mergeReactionCounts} à tous les messages présents dans l'historique. */
export function mergeReactionsByMessage(
  local: Record<string, ReactionCounts>,
  history: Record<string, ReactionCounts>,
): Record<string, ReactionCounts> {
  const merged: Record<string, ReactionCounts> = { ...local };
  for (const [messageId, counts] of Object.entries(history)) {
    merged[messageId] = mergeReactionCounts(merged[messageId] ?? {}, counts);
  }
  return merged;
}

/**
 * Contenu de l'événement analytics `CHAT_REACTION`. C'est la seule trace de la réaction côté
 * back : la conversion evergreen y lit `playbackAt` pour la placer sur l'image regardée.
 */
export function buildChatReactionAnalyticsPayload(
  messageId: number,
  reaction: string,
  playbackAt: string | undefined,
): string {
  return JSON.stringify({ messageId: messageId.toString(), reaction, playbackAt });
}
